import { useEffect, useState } from 'react';
import { isNativePlatform } from '../lib/runtime';

export function useIOSPWAInstall() {
  const [showIOSGuide, setShowIOSGuide] = useState(false);

  useEffect(() => {
    if (isNativePlatform()) return;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isStandalone = (window.navigator as any).standalone === true;

    // Also check CSS media query as fallback for some iOS browsers
    const isDisplayModeStandalone = window.matchMedia('(display-mode: standalone)').matches;

    // Show guide if iOS AND not already in standalone/installed mode
    if (isIOS && !isStandalone && !isDisplayModeStandalone) {
      // Check if user has dismissed the guide before (store in sessionStorage)
      const isDismissed = sessionStorage.getItem('ios-pwa-guide-dismissed');
      if (!isDismissed) {
        setShowIOSGuide(true);
      }
    }
  }, []);

  const dismissGuide = () => {
    setShowIOSGuide(false);
    // Remember dismissal for this session
    sessionStorage.setItem('ios-pwa-guide-dismissed', 'true');
  };

  return { showIOSGuide, dismissGuide };
}
